import { getPermissionsSso } from '@app/api/account';
import { setAuthorizationToken } from '@app/api/api';
import { Configuration, PublicClientApplication, RedirectRequest } from '@azure/msal-browser';
import notification from '@digital/ui/lib/helpers/notification';
import { useActions } from '@digital/ui/lib/store';

const msalConfig: Configuration = {
  auth: {
    clientId: '5f8db391-565c-4a65-8719-7829453ffe4b',
    authority: 'https://login.microsoftonline.com/f47270a0-d3c7-4087-9a4c-b4d829d0b243',
    redirectUri: window.location.origin + '/auth/redirect',
    knownAuthorities: ['login.microsoftonline.com'],
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest: RedirectRequest = {
  scopes: ['api://f67c02dc-7e1f-4472-b084-9456524a4f40/access_as_user'],
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Sem esta trava o logout reloga: `setIsAuthenticated` remonta a arvore e redispara
// este efeito, e o `handleRedirectPromise()` devolve a resposta memoizada do login.
let initMsalExecutado = false;

// `onAuthenticate(false)` e obrigatorio: so limpar o storage deixa o App com o
// `isAuthenticated` que ele leu no primeiro render, montando o workspace sem token.
function encerrarSessaoSso(
  loadPermissions: (perms: any[]) => void,
  onAuthenticate: (isAuthenticated: boolean) => void,
) {
  localStorage.removeItem('isAuthenticated');
  localStorage.removeItem('idtoken');
  localStorage.removeItem('expiration');
  localStorage.removeItem('userName');
  localStorage.removeItem('codigoUsuario');
  localStorage.removeItem('isMRN');
  loadPermissions([]);
  onAuthenticate(false);
}

export async function initMsal(loadPermissions: (perms: any[]) => void,onAuthenticate: (isAuthenticated: boolean) => void) {
  if (initMsalExecutado) return;
  initMsalExecutado = true;

  // Este bloco roda para todo usuario, inclusive quem entrou por usuario/senha. Falha
  // antes daqui nao e login SSO quebrado, e limpar a sessao derrubaria o fornecedor.
  let fluxoSsoIniciado = false;

  try {
    await msalInstance.initialize();
    const response: any = await msalInstance.handleRedirectPromise();

    if (!response) return;
    if (response && !response.account) return;
    fluxoSsoIniciado = true;
    console.log('[SSO] Login concluído', response.account.username);

    msalInstance.setActiveAccount(response.account);

    const scopes = ['api://f67c02dc-7e1f-4472-b084-9456524a4f40/access_as_user'];

    const tokenResponse = await msalInstance.acquireTokenSilent({
      account: response.account,
      scopes,
    });

    const accessToken = tokenResponse.accessToken;

    // Nada pode ir para `idtoken` antes do JWT local: o token do Azure nao tem a claim
    // `id`, e as telas que leem `getLoggedId()` no render montariam vazias para sempre.
    console.log('[SSO] Chamando getPermissions (merge do token local)...');
    const result: any = await getPermissionsSso(accessToken);

    if (!result || !result.token) {
      encerrarSessaoSso(loadPermissions, onAuthenticate);
      notification.error('Não foi possível concluir o login. Tente novamente.');
      return;
    }

    if (!result.permissions || !result.permissions.length) {
      notification.error('Você não possui acesso ao sistema.');
      encerrarSessaoSso(loadPermissions, onAuthenticate);
      return;
    }

    localStorage.setItem('idtoken', result.token);
    localStorage.setItem('codigoUsuario', result.codigoUsuario);
    localStorage.setItem('isMRN', result.isMRN);
    localStorage.setItem('expiration', String(Math.floor(tokenResponse.expiresOn!.getTime() / 1000)));
    localStorage.setItem('userName', response.account.username);
    localStorage.setItem('isAuthenticated', 'true');

    setAuthorizationToken(result.token);

    //console.log('[SSO] Permissões carregadas:', result.permissions);
    loadPermissions(result.permissions);
    onAuthenticate(true);
  } catch (e) {
    console.error('[SSO] erro MSAL', e);

    if (fluxoSsoIniciado) {
      encerrarSessaoSso(loadPermissions, onAuthenticate);
      notification.error('Não foi possível concluir o login. Tente novamente.');
    }
  }
}
